<button
  class="primary open-contacts-btn"
  color="primary"
  (click)="openContactsList()"
>
  {{ searchType }} LIST
</button>
